import { createFileRoute } from "@tanstack/react-router";
import { SliderExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/interactive/slider")({
  component: SliderExamples,
});
